module.exports = __webpack_public_path__ + "media/images/pokerroom/888/why-pict-a5a85e88292608cf1d47c13ac21bfbf6.jpg";